import Vue from 'vue'
import App from './views/app/App.vue'
import router from './router'
import store from './store'
import { apolloProvider } from '@/services/apollo-service'
import vuetify from './plugins/vuetify'
import { Auth0Plugin } from './auth'
import '@/design/main.pcss'
import '@/components'

Vue.config.productionTip = false

Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH_DOMAIN,
  clientId: process.env.VUE_APP_AUTH_CLIENT_ID,
  audience: process.env.VUE_APP_AUTH_AUDIENCE,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname,
    )
  },
})

new Vue({
  router,
  store,
  apolloProvider,
  vuetify,
  render: h => h(App),
}).$mount('#app')
